/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:06:52
 * @FilePath: \baishu_react_ui\src\components\BsyAlertQrcode\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import AlertQrcode from './Staticize'

const BsyAlertQrcode = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if(document.getElementsByClassName("BsyAlertQrcode").length>0){
            document.getElementsByClassName("BsyAlertQrcode")[0].removeChild(document.getElementsByClassName("BsyAlertQrcode")[0].firstChild);
            holder = document.getElementsByClassName("BsyAlertQrcode")[0]
        }else{
            holder = document.createElement('div');
            holder.style.zIndex = window.FX.STATIC.zIndex++
            holder.classList.add("BsyAlertQrcode");
            if(props.anchor){
                props.css = null;
            }else{
                document.body.appendChild(holder)
            }

        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertQrcodeContent");
        !!props.theme && holderTo.classList.add(props.theme);
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        if(props.anchor){
            props.css = null;
            props.anchor.appendChild(holderTo)
        }else{
            holder.appendChild(holderTo)
        }


        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertQrcodeContent").length>1){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }

        const newProps={...props,target:holderTo}

        ReactDOM.render(
            <AlertQrcode
                {...newProps}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('BsyAlertQrcode',res);
    })

export default BsyAlertQrcode